export const daysFromToday = (date) => {
  const d1 = new Date(date);
  const d2 = new Date();

  let difference = d1.getTime() - d2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24)) * -1;
  return `${TotalDays} días`;
};
